import { db } from '../db';
import { getBridge } from '@/platform';
import { learningCsv, scoresCsv, trialsLongCsv } from './csv';

const stamp = () => new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);

export async function exportLearningCsv(): Promise<void> {
  const records = await db.learningSessions.toArray();
  await getBridge().exportFile(`cbmi_interpretation_${stamp()}.csv`, 'text/csv;charset=utf-8', new Blob(['\uFEFF', learningCsv(records)]));
}

export async function exportTrialsCsv(): Promise<void> {
  const [sessions, trials] = await Promise.all([db.sessions.toArray(), db.trials.orderBy('[sessionId+trialIndex]').toArray()]);
  await getBridge().exportFile(`cbmi_trials_long_${stamp()}.csv`, 'text/csv;charset=utf-8', new Blob(['﻿', trialsLongCsv(sessions, trials)]));
}

export async function exportScoresCsv(): Promise<void> {
  const [sessions, scores] = await Promise.all([db.sessions.toArray(), db.scores.toArray()]);
  await getBridge().exportFile(`cbmi_scores_${stamp()}.csv`, 'text/csv;charset=utf-8', new Blob(['﻿', scoresCsv(sessions, scores)]));
}

/** 전체 JSON 번들 — 세션 메타(시드·해시·기기) 포함. 재현·감사용. */
export async function exportJsonBundle(): Promise<void> {
  const [participants, sessions, trials, events, scores, protocols, learningSessions, programs, journeys] = await Promise.all([
    db.participants.toArray(), db.sessions.toArray(), db.trials.orderBy('[sessionId+trialIndex]').toArray(), db.events.toArray(), db.scores.toArray(),
    db.protocols.toArray(), db.learningSessions.toArray(), db.programs.toArray(), db.journeys.toArray(),
  ]);
  const bundle = { exportedAt: new Date().toISOString(), schemaVersion: 5, appVersion: __APP_VERSION__, signConvention: 'vigilance-positive', participants, sessions, trials, events, scores, protocols, learningSessions, programs, journeys };
  await getBridge().exportFile(`cbmi_bundle_${stamp()}.json`, 'application/json', new Blob([JSON.stringify(bundle, null, 2)]));
}
